function initUserDestroyModal() {
  const userDestroyModal = $('#user-destroy-modal');
  const emailField = $('#email');
  const deleteUserSubmitButton = $('#delete-user-submit-button');
  if (userDestroyModal.length === 0 || emailField.length === 0 || deleteUserSubmitButton.length === 0) return;
  if (userDestroyModal.attr('data-delete-modal-initialized') === 'true') return;
  userDestroyModal.attr('data-delete-modal-initialized', 'true');

  var sSmodal = userDestroyModal.modal({ backdrop: 'static', keyboard: false, show: true });
  const isParent = $('#is_parent').val() === 'true';
  const step_2_enabled = $('#step_2_enabled').val() === 'true';
  const updateDeleteUserSubmitButtonState = function () {
    deleteUserSubmitButton.prop('disabled', emailField.val().trim().length === 0);
  };

  deleteUserSubmitButton.on('click', function (event) {
    event.preventDefault();
    if (isParent) {
      $('#user-destroy-modal .step1').attr('hidden', 'hidden');
      $('#user-destroy-modal .step2').attr('hidden', 'hidden');
      $('#user-destroy-modal .step-parent').removeAttr('hidden');
      sSmodal.modal('show');
      return;
    } else {
      $('#user-destroy-modal .step1').removeAttr('hidden');
      $('#user-destroy-modal .step2').attr('hidden', 'hidden');
      $('#user-destroy-modal .step-parent').attr('hidden', 'hidden');
      sSmodal.modal('show');
    }
  });

  // First to second step
  $('#user-destroy-step1-submit').on('click', function () {
    if (step_2_enabled) {
      $('#user-destroy-modal .step1').attr('hidden', 'hidden');
      $('#user-destroy-modal .step2').removeAttr('hidden')
    } else {
      $('#user-destroy-form').trigger('submit');
    }
  });

  $('#user-destroy-step1-cancel').on('click', function () {
    sSmodal.modal('hide');
  });

  $('#user-destroy-step2-cancel').on('click', function () {
    sSmodal.modal('hide');
  });

  $('#user-destroy-step2-submit').on('click', function () {
    $('#user-destroy-form').trigger('submit');
  });

  $('#user-destroy-parent-cancel').on('click', function () {
    sSmodal.modal('hide');
  });

  $('#user-destroy-parent-submit').on('click', function () {
    $('#user-destroy-form').trigger('submit');
  });

  emailField.on('input change keyup', updateDeleteUserSubmitButtonState);
  updateDeleteUserSubmitButtonState();
}

function bootUserDestroyModal() {
  initUserDestroyModal();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootUserDestroyModal);
} else {
  bootUserDestroyModal();
}

document.addEventListener('turbo:load', bootUserDestroyModal);
document.addEventListener('turbolinks:load', bootUserDestroyModal);
document.addEventListener('page:load', bootUserDestroyModal);
